import ConfirmBoxModal from "components/ConfirmBoxModal";
import Timer from "components/Timer";
import React, { useState } from "react";
import LeasedEquipmentStatusDetails from "./LeasedEquipmentStatusDetails";
import CancelButton from "components/CancelButton";
import SubmitHookForm from "components/SubmitHookForm";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilState, useSetRecoilState } from "recoil";
import { ILeasedEquipStatus } from "../Types";
import {
  addStateStatus,
  editStateStatus,
  rowEditStatus,
  savingStatus,
  statusFetching,
} from "../atoms/atoms";
import useUpdateLeasedEquipmentStatus from "../hooks/useUpdateLeasedEquipmentStatus";
import useAddLeasedEquipmentStatus from "../hooks/useAddLeasedEquipmentStatus";

export default function LeasedEquipmentStatusForm(props: {
  reFetch: () => void;
}) {
  // Drilled Props
  const { reFetch } = props;
  // Atom States
  const [isAddState, setIsAddState] = useRecoilState(addStateStatus);
  const [actionEditState, setActionEditState] = useRecoilState(editStateStatus);
  const [isSaving, setIsSaving] = useRecoilState(savingStatus);
  const [editData, setEditData] = useRecoilState(rowEditStatus);
  const setIsFetching = useSetRecoilState(statusFetching);

  // Local States
  const [newData, setNewData] = useState<ILeasedEquipStatus>();
  const [saveModal, setSaveModal] = useState(false);
  const [changes, setChanges] = useState(false);

  // Hook Functions
  const updateData = useUpdateLeasedEquipmentStatus();
  const addData = useAddLeasedEquipmentStatus();

  // Form Functions
  const useFormMethods = useForm({
    defaultValues: { ...editData },
  });

  const onSubmit = (data) => {
    const value = {
      ...data,
      leasedEquipmentStatusName: data.leasedEquipmentStatusName.trim(),
    };
    setNewData(value);
    setSaveModal(true);
    setChanges(false);
    setIsSaving(true);
  };

  const handleCancel = () => {
    useFormMethods.reset();
    useFormMethods.clearErrors();
    setEditData(undefined);
    setIsAddState(false);
    setActionEditState(false);
  };

  const handleSave = async () => {
    if (newData) {
      if (actionEditState) {
        updateData(newData);
      } else {
        addData(newData);
      }
    }

    await Timer(100);
    setIsFetching(true);
    useFormMethods.reset();
    useFormMethods.clearErrors();
    setIsSaving(false);
    setEditData(undefined);
    setIsAddState(false);
    setActionEditState(false);
    reFetch();
  };
  return (
    <>
      <div className="px-2 py-2 space-y-2 border-l-2 border-primary box-shadow">
        <FormProvider {...useFormMethods}>
          <form onSubmit={useFormMethods.handleSubmit(onSubmit)}>
            <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg pb-1">
              <div className="ml-2 font-bold text-primary text-base">
                {isAddState ? "Add New Status" : "Edit Status"}
              </div>
              <div className="flex justify-between gap-2 mr-2">
                <SubmitHookForm
                  type="submit"
                  disabled={!changes}
                  buttonText={isSaving ? "Saving.." : "Save"}
                  className={undefined}
                  onClick={undefined}
                />
                <CancelButton
                  onClick={(event) => {
                    event.preventDefault();
                    handleCancel();
                  }}
                />
              </div>
            </div>
            <div className="mx-2 border-b-2 border-secondary"></div>
            <div className="text-xs text-secondary italic font-normal mt-2 ml-2">
              <b> Note:</b> All fields with * are required to fill.
            </div>
          </form>
          <div>
            <LeasedEquipmentStatusDetails
              data={editData}
              setChanges={setChanges}
            />
          </div>
        </FormProvider>
      </div>

      {saveModal && (
        <ConfirmBoxModal
          ModalTitle={isAddState ? "Add Status" : "Update Status"}
          qConfirmation={`Are you sure you want to ${
            isAddState ? "add " : "update "
          } this?`}
          isOpen={saveModal}
          onClose={() => {
            setSaveModal(false);
            setIsSaving(false);
            setChanges(true);
          }}
          onClickFunction={() => {
            setSaveModal(false);
            handleSave();
          }}
          cancelButtonRef={undefined}
        />
      )}
    </>
  );
}
